
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#bac1cc","data-name":"Group 132433"}},[_c('path',{attrs:{"data-name":"Path 29667","d":"M11.911 5.415H4.268a.764.764 0 110-1.529h7.643a.764.764 0 110 1.529z"}}),_c('path',{attrs:{"data-name":"Path 29668","d":"M8.089 5.414a.764.764 0 01-.764-.764V3.121a.764.764 0 011.529 0V4.65a.764.764 0 01-.765.764z"}}),_c('path',{attrs:{"data-name":"Path 29669","d":"M5.032 14.586a.764.764 0 01-.485-1.355 11.759 11.759 0 002.97-3.645 11.9 11.9 0 001.336-4.969.781.781 0 01.798-.731.764.764 0 01.731.8 13.43 13.43 0 01-1.51 5.61 13.263 13.263 0 01-3.354 4.116.764.764 0 01-.486.174z"}}),_c('path',{attrs:{"data-name":"Path 29670","d":"M15.732 17.642a.764.764 0 01-.745-.6l-1.28-5.759a.665.665 0 00-1.3 0l-1.28 5.759a.764.764 0 11-1.492-.332l1.283-5.757a2.193 2.193 0 014.28 0l1.28 5.759a.764.764 0 01-.58.912.778.778 0 01-.166.018z"}}),_c('path',{attrs:{"data-name":"Path 29671","d":"M8.854 13.057a.759.759 0 01-.352-.086 6.832 6.832 0 01-2.569-2.315 6.7 6.7 0 01-.877-1.994.764.764 0 111.477-.382 5.169 5.169 0 00.677 1.542 5.312 5.312 0 001.993 1.793.764.764 0 01-.353 1.442z"}}),_c('path',{attrs:{"data-name":"Path 29672","d":"M14.968 14.586h-3.822a.764.764 0 110-1.529h3.821a.764.764 0 010 1.529z"}})])])
          )
        }
      }
    